<template>
  <div class="closed vh-100 d-flex flex-column">
    <b-container fluid="fluid p-0 flex-grow-1 bg-salmon-500">
      <b-row class="no-gutters h-100">
        <div class="child-image-wrapper px-0">
          <Logo background file="logoClosed.svg" class="logo bg-white img-fluid"></Logo>
          <div class="children-image">
            <picture>
              <source
                media="(min-width:769px)"
                srcset="@/assets/images/foto_zaslepka_gwiazdki_desktop.png"
              />
              <img src="@/assets/images/foto_zaslepka_gwiazdki_768.jpg" alt="" />
            </picture>
          </div>
        </div>
        <div class="help-description-wrapper">
          <div class="help-description">
            <div class="header-info">
              <h2 class="awarded">
                <div v-orphans>
                  <slot name="title"></slot>
                </div>
              </h2>
            </div>
            <div class="pay-info text-center my-5">
              <p>
                <slot name="want-donate">
                  <span v-html="$t('closed.want-donate')"></span>
                </slot>
              </p>
              <a
                class="btn font-weight-bold btn-primary"
                href="https://akademiaprzyszlosci.org.pl/wplacam"
              >
                {{ $t('closed.donate') }}
                <i class="angle-right-icon ml-2 bg-white" style="height: 0.9rem"></i
              ></a>
            </div>
            <div class="contact-info">
              <p><slot name="donate-info"></slot></p>
              <div class="envelope">
                <img :src="emailWhiteImage" alt="email" />
                <div>
                  <p>{{ $t('closed.contact-with-us') }}</p>
                  <a :href="'mailto:' + $t('closed.mail')">{{ $t('closed.mail') }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-row>
    </b-container>
    <ScrollTopButton />
    <AppFooter ovalBackground="blue-450" class="flex-grow-0"></AppFooter>
  </div>
</template>

<script setup lang="ts">
import AppFooter from '@/components/global/AppFooter.vue'
import ScrollTopButton from '@/components/widgets/ScrollTopButton.vue'
import Logo from '@/components/widgets/Logo.vue'

const emailWhiteImage = new URL('/src/assets/svg/emailWhite.svg', import.meta.url).href
</script>
